import React from "react";
import * as Button from "../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import useExternalPriceTaxDisclaimer from "../../../../hooks/shared/useExternalPriceTaxDisclaimer";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import * as BasketList from "../basket/styles/BasketList";
import { useBnbSelector } from "../../../../redux/store";
import { PromotionTypeEnum } from "../../../../../../../common-deprecated/types/CommonTypes";
import PricePromoIcon from "./PricePromoIcon";

const ExternalPriceTaxDisclaimer = (): JSX.Element | null => {
    const {
        visible,
        fullTaxLabel,
        co2TaxLabels,
        formattedTax,
        showCo2Disclaimer,
        formattedValueBeforeTax,
        showValueBeforeTax,
    } = useExternalPriceTaxDisclaimer();

    const { promotions } = useBnbSelector((state) => state.items);

    const [basketTaxDisclaimerContent, basketTaxDisclaimerTitle] = useBnbOptionalLabel([
        "basketTaxDisclaimerContent",
        "basketTaxDisclaimerTitle",
    ]);

    if (!visible) return null;
    return (
        <BasketList.BasketList mt={2}>
            {showValueBeforeTax && (
                <BasketList.BasketListItem>
                    <BasketList.ListItemLabel>
                        <BasketList.ListItemLabelText>
                            <BnbLabel label="basketTotalValueBeforeTax" />
                        </BasketList.ListItemLabelText>
                    </BasketList.ListItemLabel>
                    <BasketList.ListItemValue hasPrice>
                        <span dangerouslySetInnerHTML={{ __html: formattedValueBeforeTax }} />
                    </BasketList.ListItemValue>
                </BasketList.BasketListItem>
            )}
            <BasketList.BasketListItem>
                <BasketList.ListItemLabel>
                    {co2TaxLabels ? (
                        <BasketList.ListItemLabelText>
                            {co2TaxLabels.start}
                            {co2TaxLabels.value}
                            &nbsp;
                            <Button.Link
                                onClick={(event) => {
                                    event.preventDefault();
                                    showCo2Disclaimer();
                                }}
                            >
                                <IconWrapper>
                                    <Icon variant="info" />
                                </IconWrapper>
                            </Button.Link>
                            {co2TaxLabels.end}
                        </BasketList.ListItemLabelText>
                    ) : (
                        <BasketList.ListItemLabelText>{fullTaxLabel}</BasketList.ListItemLabelText>
                    )}
                </BasketList.ListItemLabel>
                <BasketList.ListItemValue hasPrice>
                    <span dangerouslySetInnerHTML={{ __html: formattedTax }} />
                </BasketList.ListItemValue>
                {basketTaxDisclaimerContent && basketTaxDisclaimerTitle && (
                    <PricePromoIcon
                        promotions={[
                            {
                                amount: Number(formattedTax.match(/^\d+/) ? [0] : 0),
                                description: basketTaxDisclaimerContent,
                                id: `${basketTaxDisclaimerTitle}-${promotions.length + 1}`,
                                index: promotions.length + 1,
                                name: basketTaxDisclaimerTitle,
                                type: PromotionTypeEnum.None,
                            },
                        ]}
                    />
                )}
            </BasketList.BasketListItem>
        </BasketList.BasketList>
    );
};

export default ExternalPriceTaxDisclaimer;
